import 'core-js/stable';
import Vue from 'vue';
import CoreuiVue from '@coreui/vue';
import App from './App';
import router from './router/index';
//import { iconsSet as icons } from './assets/icons/icons.js'
import { freeSet as icons   }  from '@coreui/icons';
import store from './store';
import vuexI18n from 'vuex-i18n';
import Locales from './locale/vue-i18n-locales.generated.js';
import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue';
import VueMaterial from 'vue-material';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'
import VueAxios from 'vue-axios';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import VueCryptojs from 'vue-cryptojs';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf, faFileCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//import ThemifyIcon from "vue-themify-icons";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueFormWizard from 'vue-form-wizard';
import VueFormGenerator from 'vue-form-generator';
import 'vue-form-generator/dist/vfg.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import Vue2Filters from 'vue2-filters';

import VueMeta from 'vue-meta'
import VueHead from 'vue-head'
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);

Vue.use(VueHead)//para titulo dinamico
Vue.use(VueMeta)//para metadatos Open Graph para WhatsApp// Containers

library.add(faFilePdf, faFileCode)


// Vue.use(ThemifyIcon);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueMaterial)
Vue.use(Vue2Filters)
Vue.use(VueFormWizard)
Vue.use(VueFormGenerator)
Vue.use(VueSweetalert2);
Vue.use(VueCryptojs)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(CoreuiVue)
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', Locales.en);
Vue.i18n.add('es', Locales.es);
Vue.i18n.set(locale);

// Servidores para desarrollo
// const server = "http://192.168.1.71:8000";
// const serverFront = "http://192.168.1.71:8080";
// const url = 'https://pagosprueba.s3.amazonaws.com/';

// Servidores para producción
const server = "https://lybflow.link";
const serverFront = "https://lybflow.app";
const url = 'https://pagosfile.s3-us-west-2.amazonaws.com/';

Vue.prototype.$apiAdress = server;
Vue.prototype.$apiAdressF = serverFront;
Vue.prototype.$prefijoamazon = url;
Vue.prototype.$keysecret = 'evolucionweb';
Vue.prototype.$getLogoBanco = function(logo) {
    try {
        const bancosSaved = localStorage.getItem('bancos');        
        // Si hay datos en localStorage, intentamos parsearlos
        if (bancosSaved) {
            const urlsLogosBancosJson = JSON.parse(bancosSaved);
            // Verificamos si la URL del logo existe en el objeto
            if (urlsLogosBancosJson[logo]) {
                return urlsLogosBancosJson[logo];
            }
        }        
        // Si no se encuentra en localStorage, devolvemos la URL normal
        return url + logo;
    } catch (error) {
        console.error('Error al obtener el logo del banco:', error);
        // En caso de error, devolvemos la URL normal como fallback
        return url + logo;
    }
};

let locale = 'es';

if (typeof localStorage.locale !== 'undefined') {
    locale = localStorage.getItem("locale")
}

try {
    let user = 'user'; ///usuio registrador anteriormente
    let token = 'token'; // token valido del usuario
    let roles = 'roles'; ///roles para este usuario
    let tema = "tema";
    let metodo = "metodo";
    if (localStorage.getItem(user) && localStorage.getItem(token)) {
        let usuario = {
            user: null,
            token: null,
            roles: null,
            tema: null,
            metodo: null
        };
        usuario.user = localStorage.getItem(user);
        usuario.token = Vue.CryptoJS.AES.decrypt(localStorage.getItem(token).toString(), Vue.prototype.$keysecret).toString(Vue.CryptoJS.enc.Utf8);
        usuario.roles = localStorage.getItem(roles);
        usuario.tema = localStorage.getItem(tema);
        usuario.metodo = localStorage.getItem(metodo);
        store.commit('setUserActionMain', usuario);
    } else {
        store.commit('setUserActionMain', null);
    }
} catch (error) {

}

new Vue({
    el: '#app',
    router,
    store,
    //CIcon component documentation: https://coreui.io/vue/docs/components/icon
    icons,
    template: '<App/>',
    components: {
        App,
    }
})
